import useInterval from './useInterval'; // Adjust path as needed

export default function ModalCleanup() {
  useInterval(() => {
    // Check if body has the modal open class
    const bodyHasModalClass = document.body.classList.contains('ReactModal__Body--open');
    if (bodyHasModalClass) {
      // Check if overlay exists
      const overlay = document.querySelector('.ReactModal__Overlay--after-open');

      // If overlay doesn't exist, remove body class
      if (!overlay) {
        console.info(
          'No modal overlay found, removing ReactModal__Body--open class from body.',
        );
        document.body.classList.remove('ReactModal__Body--open');
      }
    }
  }, 5000); // 5 seconds

  return null; // Component doesn't render anything
}
